import { useState, useEffect } from 'react'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Services from '@/pages/Services'
// import Gallery from '@/pages/Gallery'
import Reviews from '@/pages/Testimonials'
import Estimate from '@/pages/Estimate'
import Appointment from '@/pages/Appointment'
// Import service pages
import Decks from '@/pages/services/decks'
import Pergolas from '@/pages/services/pergolas-and-privacy-walls'
import LivingSpaces from '@/pages/services/living-spaces'
import Railings from '@/pages/services/railings'
import Fences from '@/pages/services/fences'
import Landscaping from '@/pages/services/landscaping'
// Import gallery pages
// import DecksGallery from '@/pages/gallery/decks'
// import PergolasGallery from '@/pages/gallery/pergolas-and-privacy-walls'
// import LivingSpacesGallery from '@/pages/gallery/living-spaces'
// import RailingsGallery from '@/pages/gallery/railings'
// import FencesGallery from '@/pages/gallery/fences'
// import LandscapingGallery from '@/pages/gallery/landscaping'
import BlogPost1 from '@/pages/blog/1'
import BlogPost2 from '@/pages/blog/2'
import BlogPost3 from '@/pages/blog/3'


function App() {
  const [currentPath, setCurrentPath] = useState('/')
  
  useEffect(() => {
    // Set initial path
    setCurrentPath(window.location.pathname)
    
    // Listen for path changes
    const handlePathChange = () => {
      setCurrentPath(window.location.pathname)
      // Scroll to top on route change
      window.scrollTo(0, 0)
    }
    
    window.addEventListener('popstate', handlePathChange)
    
    return () => {
      window.removeEventListener('popstate', handlePathChange)
    }
  }, [])
  
  // Simple client-side router
  const renderContent = () => {
    switch(currentPath) {
      case '/':
        return <Home />
      case '/about-us':
        return <About />
      case '/services':
        return <Services />
      // case '/gallery':
      //   return <Gallery />
      case '/testimonials':
        return <Reviews />
      case '/estimate':
        return <Estimate />
      case '/appointment':
        return <Appointment />
      // Service page routes
      case '/services/decks':
        return <Decks />
      case '/services/pergolas-and-privacy-walls':
        return <Pergolas />
      case '/services/living-spaces':
        return <LivingSpaces />
      case '/services/railings':
        return <Railings />
      case '/services/fences':
        return <Fences />
      case '/services/landscaping':
        return <Landscaping />
      // Gallery page routes
      // case '/gallery/decks':
      //   return <DecksGallery />
      // case '/gallery/pergolas-and-privacy-walls':
      //   return <PergolasGallery />
      // case '/gallery/living-spaces':
      //   return <LivingSpacesGallery />
      // case '/gallery/railings':
      //   return <RailingsGallery />
      // case '/gallery/fences':
      //   return <FencesGallery />
      // case '/gallery/landscaping':
      //   return <LandscapingGallery />
      // Blog post routes
      case '/blog/1':
        return <BlogPost1 />
      case '/blog/2':
        return <BlogPost2 />
      case '/blog/3':
        return <BlogPost3 />
      default:
        return <Home />
    }
  }
  
  return (
    <div>
      {renderContent()}
    </div>
  )
}

export default App 